import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Award, Briefcase, GraduationCap, Mail, Phone, ArrowRight } from 'lucide-react';
import SectionTitle from '../components/ui/SectionTitle';
import Button from '../components/ui/Button';
import InquiryForm from '../components/home/InquiryForm';
import WhatsAppFloatingButton from '../components/layout/WhatsAppFloatingButton';

// Import local image
import leadershipImg from '../assets/theleadership.png';
import person1 from '../assets/person1.png';
import person2 from '../assets/person2.png';
import person3 from '../assets/person3.png';


const teamMembers = [
  {
    name: "Adv. Pintu Arjun Yadav",
    designation: "Founder & Lead Advocate",
    qualification: "M.COM, BBI, LL.B",
    experience: "8+ Years",
    specialization: "Criminal & Civil Litigation",
    image: person1,
    bio: "Adv. Pintu Arjun Yadav brings a unique combination of financial literacy and legal expertise. With a background in Commerce and Law, he provides strategic counsel that aligns legal solutions with business objectives.",
    email: "akylegalconsultants@gmail.com",
    phone: "+91 97694 15432"
  },
  {
    name: "Adv. Biswa Ranjan Palo",
    designation: "Senior Associate",
    qualification: "M.com, LLB",
    experience: "1+ Years",
    specialization: "Advocate Bombay High Court",
    image: person2,
    bio: "Adv. Biswa Ranjan Palo specializes in Trademark, Society matters, family law matters with a compassionate approach. He has successfully handled numerous divorce, child custody, and domestic violence cases.",
    email: "akylegalconsultants@gmail.com",
    phone: "+91 97694 15432"
  },
  {
    name: "ADV. Mohammed Fareeduddin Siddiqui",
    designation: "Senior Associate",
    qualification: "LL.M, LL.B",
    experience: "3+ Years",
    specialization: "Criminal and Civil",
    image: person3,
    bio: "Adv. Mohammed Fareeduddin Siddiqui is a dedicated legal professional specializing in Civil and Criminal Law. He is committed to delivering high-quality legal solutions tailored to the unique circumstances of each case. Known for his compassionate approach, he strives to alleviate the stress of legal proceedings by maintaining transparent communication and providing steadfast support, ensuring his clients feel understood and confident every step of the way.",
     email: "akylegalconsultants@gmail.com",
    phone: "+91 97694 15432"
  }
  
];

const TheLeadership = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-primary-blue min-h-[35vh] flex items-center">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-60"
          style={{ backgroundImage: `url(${leadershipImg})` }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center text-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">The Leadership</h1>
              <p className="text-xl text-gray-300">Meet our experienced legal team</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Left Column - Team Members */}
          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {teamMembers.map((member, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300">
                  <div className="h-64 overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover object-[center_20%] hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-primary-blue mb-1">{member.name}</h3>
                    <p className="text-gold font-semibold mb-3">{member.designation}</p>
                    
                    <div className="space-y-2 mb-4">
                      <div className="flex items-center text-dark-gray text-sm">
                        <GraduationCap className="w-4 h-4 text-gold mr-2" />
                        <span>{member.qualification}</span>
                      </div>
                      <div className="flex items-center text-dark-gray text-sm">
                        <Briefcase className="w-4 h-4 text-gold mr-2" />
                        <span>{member.experience}</span>
                      </div>
                      <div className="flex items-center text-dark-gray text-sm">
                        <Award className="w-4 h-4 text-gold mr-2" />
                        <span>{member.specialization}</span>
                      </div>
                    </div>

                    <p className="text-dark-gray text-sm mb-4">{member.bio}</p>

                    <div className="flex space-x-3">
                      <a href={`mailto:${member.email}`} className="p-2 bg-gray-100 rounded-lg hover:bg-gold transition-colors duration-200">
                        <Mail className="w-4 h-4 text-dark-gray hover:text-white" />
                      </a>
                      <a href={`tel:${member.phone}`} className="p-2 bg-gray-100 rounded-lg hover:bg-gold transition-colors duration-200">
                        <Phone className="w-4 h-4 text-dark-gray hover:text-white" />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Inquiry Form */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-xl p-6 sticky top-24">
              <h3 className="text-2xl font-bold text-primary-blue mb-6 text-center">Free Consultation</h3>
              <InquiryForm />
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <WhatsAppFloatingButton />
    </div>
  );
};

export default TheLeadership;